import Vue from 'vue'
import Api from '@/api'
import config from '@/config'

export const store = Vue.observable({
  search: null,
  results: [],
  apiKey: null,
  loading: false,
  searchMode: 'public',
  mapsLoaded: false,
  allSystemsReturned: false
})

export const mutations = {
  setSearch(newSearch) {
    store.search = newSearch
  },
  setResults(newResults) {
    store.results = newResults
  },
  appendResults(newResults) {
    let results = [
      ...store.results,
      ...newResults
    ]
    
    store.results = results
  },
  setApiKey(newKey) {
    store.apiKey = newKey
  },
  setMapsLoaded(value) {
    store.mapsLoaded = value
  },
  setSearchMode(value) {
    store.searchMode = value
  }
}

export const actions = {
  getSearchResults(search) {
    store.loading = true
    store.allSystemsReturned = false
    mutations.setSearch(search)   
    mutations.setResults([])
    return Promise.all(config.API_SYSTEMS.map(system =>  {
      return Api.getSearchResults(search, store.apiKey, system, store.searchMode === 'private')
        .then(data => {
          store.loading = false          
          if (data.orders) {
            mutations.appendResults(data.orders)         
          }
        })
        .catch(() => {
          store.loading = false
        })
    })).finally(() => {
      store.allSystemsReturned = true
    })    
  },

  shareResult (email, url) {
    return Api.shareResult(email, url)
  }
}

export const getters = {
  getResultById(id) {
    const result = store.results.find(result => {
      return result.details.uniqueId == id
    })
    return result
  },

  deliveredPackages( result ) {
    let packages = []
    const deliveries = result.orderStatuses.filter(status => status.status == 'delivered')
    deliveries.forEach(delivery => {
      const ids = delivery.packageIds
      for (let i = 0, j = ids.length; i < j; i++) {
        if (packages.includes(ids[i]) === false) {
          packages.push(ids[i])
        }
      }
    })
    
    return packages
  }
}

if (window.appData && window.appData.apiKey) {
  mutations.setApiKey(window.appData.apiKey)
}

